export default __webpack_public_path__ + "static/media/AdobeStock_222880408_Preview-Recovered.cefbafea.jpg";